import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'

const NeZnainiteView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ХОРАТА РАЗКАЗИ</h1>
                        <p className="lead">(НE)ЗНАЙНИТЕ ХОРА РАЗКАЗИ</p>
                    </div>
                    <p>
                        Взрем ли се и още в жития-битията и на другите хората разкази от условното „Царството Паисиада", ще разпознаем, че
                        някои от тях са пожелали да ни съобщят имената си. Изписвали са ги главно в бележки, разхвърляни по страниците на
                        ръкописните преписи и преправки. Другите пък са укривали имената си, преминавайки като невидими минувачи през
                        възрожденското време. Така анонимно е вървял във физическия си път отсам преписвачът на Жеравненскияпрепис; така
                        анонимно е вървял по пътя си отсам и преписвачът на Вторя Самоковски препис. Пак така, без никаква вест за
                        преписвача, и днес в Патриаршеската библиотека в Белград продължава да живее и Карловацкият препис (Pъкопис № Р
                        140), също и Кларковата преправка, която пък се пази в Охайо (Ръкопис № OSU, HRL 1). Оригиналът на Чертковия препис
                        пък е съхранил памет за различни почерци – и на преписвача, и на поне още двама коректори на преписа, но имената им
                        не са опазени със сигурност (читателят вече познава и тази диря). Все хора разкази, които добавят нови и нови, и
                        нови… обрамчващи истории. А аз и ти, читателю, едва ли някога ще разпознаем какъв е бил човешкият им ръст. И дали
                        ръката, която е писала ред подир ред, е бивала уморена. И каква е била онази биохимия на тяхната кръв, която ги е
                        карала така горещо да обичат поробената България. Може би няма да узнаем нищо повече за Тях, но пък знаем немалко
                        от имената на преписвачите на „Паисиада". Затова нека заедно да ги изговорим молитвено отново. Да го сторим сега. И
                        заради Тях, а и заради нас самите.
                    </p>
                    <p>
                        Знайни в Българската възрожденска ръкописна „Паисиада" са имената на хората разкази:
                    </p>
                    <ul>
                        <li>йеромонах Паисий проигумен Хилендарски;</li>
                        <li>Стойко йерей от Котел (преписал два пъти Паисиевата История);</li>
                        <li>поп Алекси Велкович Попович от Самоков;</li>
                        <li>монах Никифор Рилец от Рилския манастир;</li>
                        <li>поп Стоян Кованлъшки от с. Кованлък, Великотърновско;</li>
                        <li>даскал Дойно Граматик от Елена;</li>
                        <li>поп Пунчо от село Мокреш, Ломско;</li>
                        <li>отец Панталеймон проигумен Хилендарски;</li>
                        <li>бояджията Влад Поппетков Гладичов от Габрово;</li>
                        <li>даскал Никола Поплазаров от Русе;</li>
                        <li>монах Паисий Рилски от Рилския манастир;</li>
                        <li>монах Панталеймон от Сопотския манастир;</li>
                        <li>даскал Георги от Дряново;</li>
                        <li>даскал Стефан поп Зотов от Дряново;</li>
                        <li>даскал Сава Доброплодни от Сливен;</li>
                        <li>даскал Тодор Пирдопски;</li>
                        <li>учениците Петко Р. Славейков и Христо Драганов от Велико Търново, преписвали два или три пъти „История славянобългарска";</li>
                        <li>Кънчо Стоянович Бакал от Велико Търново, преписал с иждивението на търговеца Стоянчо Пенев Ахтар Паисиевата книга;</li>
                        <li>ученикът Тодор Шишков от Велико Търново;</li>
                        <li>поп Василий Мануилов, родом от Сливен, но преселник в Бесарабия;</li>
                        <li>даскал Драгия Ненов, родом от Вишовград;</li>
                        <li>монах Паисий Николаевич от Рилската света обител;</li>
                        <li>поп Йоаникия Петкович от Змеево;</li>
                        <li>йеромонах Харитон от Рилския манастир (преписал три пъти „История славянобългарска");</li>
                        <li>даскал Найден Геров от Копривщица - изтъкнат български политик, дипломат, руски вицеконсул в Пловдив;</li>
                        <li>архимандрит Онуфрий Попович Хилендарски;</li>
                        <li>Васил Станкович от Свищов;</li>
                        <li>даскал Димитър Миладинов от Охрид;</li>
                        <li>опълченецът Димитър Оджаков;</li>
                        <li>поп Костадин (Константин) Чучулайн от Банско;</li>
                        <li>дон Едуардо Валпа от Торино;</li>
                        <li>Лаврен Кьосестоянов от Пловдив;</li>
                        <li>Петър Балсамаджиев от Пловдив;</li>
                        <li>заможният търговец Васил Априлов от Габрово, преселник в Одеса (Русия);</li>
                        <li>проф. Николай Мурзакевич от Одеса;</li>
                        <li>проф. Владимир Ламански от Санкт-Петербург.</li>
                    </ul>

                    <p>
                        Взрем ли се в жития-битията на всеки от тези знайни преписвачи (някои от съставените от тях преписи вече са
                        изгубени), ще разпознаем, че в човешкия им път Те са били твърде различни хора. Били са монаси с по-нисш или
                        по-висок монашески сан (сред тях е имало и монаси таксидиоти). Били са свещеници, даскали, също и синове на
                        даскали, също и ученици. Сред тях е имало и занаятчии, и видни български книжовници, и учени. Също и изтъкнати
                        руски професори. Имало е и политици, и дипломати (за поколенията преписвачи в „Паисиада" вж. Драгова 2012: 40 -
                        46). Но, макар и различаващи се по социална и национална принадлежност, по възпитание, образование и психичен
                        градеж, всички тези хора разкази: от Стоян Кованлъшки (селски свещеник в поробена България) до Найден Геров (висок
                        политик и дипломат в Османската империя) – са притежавали едно общо чувство. Чувството за почит към духовния подвиг
                        на Отец Паисий – първия модерен разказвач на Големия разказ за изгубените царства на България и тяхната Свобода.
                    </p>
                    <p>
                        За да бъда коректна спрямо събитията на възрожденското време, ще трябва да потвърдя, че образованите преписвачи
                        (такива са били например Васил Априлов, Найден Геров) добре са осъзнавали, че Паисиевата История не е съставена от
                        обучен историк, но въпреки това пак са я преписвали на ръка. И са го правили с обич! И с кураж! Ятаганът не е само
                        метафора, сътворена от възрожденската литература, той е посичал и непокорните глави на раята, когато българи са
                        дръзвали да разправят Своята история, в земята си, бастисана от Игото. Хората разкази са го правили и с любов, и с
                        кураж, защото с кръвта си са разпознали, че „История славянобългарска" е сътворена от достоен Българин – син на
                        поробено Отечество и дете на изконната Своя земя, отвоювана със светлата кръв на Отците, но удавена в черната кръв
                        на Чедата им! Това именно съзнание е накарало Найден Геров, който е от учен поучен, той е дипломиран висшист, да
                        съхрани в преписа си на „История славянобългарска" почти дословно първото и второто от Паисиевите предисловия.
                        Геров пренася в своя препис дори мита за старозаветния праотец Ной, който Паисий разказва, защото именно в този мит
                        се отстоява, че българите се родеят с Ноевото коляно (Кръстева 2012: 163). Ако сред всичките преписвачи на
                        Паисиевата история е имало български възрожденец, сред всичките преписвачи на Паисиевата история, който да е
                        съзнавал с цялата сила на Разума си, че Ноевото присъствие в „История славянобългарска" е митично, а не
                        историческо, то този някой е именно Найден Геров. Но въпреки учеността ситъкмо Найден Геров е пожелал да „повярва"
                        на въобразената Паисиева история. Затова я и преписва точно такава, каквато я е първосътворил йеромонахът от
                        Хилендар. Защото преписването на възрожденската книга национална институция „История славянобългарска" между 1765 и
                        1882 г. е било свещен Ритуал за хората разкази – възрожденските преписвачи в „Паисиада".
                    </p>
                    <p style={{textAlign: "right"}}>
                        © Автор: доц. д-р Мила Кръстева
                    </p>
                </main>
            </div>
        </MainLayout>
    )
}

NeZnainiteView.propTypes = {

}

export default NeZnainiteView



// WEBPACK FOOTER //
// ./src/views/NeZnainite/index.jsx